import { create } from 'zustand';
import useLoadingStore from './use-loading';
import { makeRequest } from 'api/api-client';
import { HTTP } from 'constants/http-method';
import { API_ENDPOINTS } from 'api/endpoints';

const useStaffMemberStore = create((set) => ({
  staffMemberLoading: false,
  staffMembers: [],
  pagination: {
    pageSize: 10,
    totalItems: 0,
    totalPages: 0,
    currentPage: 1,
  },

  // Function to reset currentPage only when an action happens
  resetCurrentPage: () => {
    set((state) => ({
      pagination: {
        ...state.pagination,
        currentPage: 1,
      },
    }));
  },

  // Function to get members
  getStaffMember: async ({ query = null, successCallback }) => {
    set({ staffMemberLoading: true });
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.GET,
        API_ENDPOINTS.GET_CAREGIVER,
        null,
        query
      );

      if (response.success) {
        set({
          staffMembers: response.data?.data || [],
          pagination: {
            pageSize: response.data?.pagination?.limit,
            totalItems: response.data?.pagination?.total,
            currentPage: response.data?.pagination?.page,
            totalPages: response.data?.pagination?.totalPages,
          },
        });
        successCallback && successCallback();
      }
    } catch (error) {
    } finally {
      set({ staffMemberLoading: false });
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to create member
  sendInvite: async ({ data, successCallback, navigate }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.POST,
        API_ENDPOINTS.SEND_INVITE,
        data
      );

      await useStaffMemberStore.getState().getStaffMember({
        successCallback: () => {
          useStaffMemberStore.getState().resetCurrentPage(); // Reset page
          navigate(`/caregivers`);
          successCallback && successCallback(response);
        },
      });
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to update arhive/active
  updateArchive: async ({ queryParams, id, data, successCallback }) => {
    useLoadingStore.getState().setLoading(true);

    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.UPDATE_CAREGIVER_STATUS,
        data,
        null,
        id
      );

      if (response.success) {
        await useStaffMemberStore.getState().getStaffMember({
          query: queryParams,
          successCallback: () => {
            successCallback && successCallback(response);
          },
        });
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },

  // Function to reject or signedoff applicant
  updateSignedOffStatus: async ({
    queryParams,
    id,
    data,
    activeButton,
    successCallback,
  }) => {
    useLoadingStore.getState().setLoading(true);
    try {
      const { data: response } = await makeRequest(
        HTTP.PUT,
        API_ENDPOINTS.CAREGIVER_SIGNEDOFF_STATUS,
        data,
        null,
        id
      );

      if (response.success) {
        await useStaffMemberStore.getState().getStaffMember({
          query: queryParams,
          successCallback: () => {
            successCallback && successCallback(response);
          },
        });
      }
    } catch (error) {
    } finally {
      useLoadingStore.getState().setLoading(false);
    }
  },
}));

export default useStaffMemberStore;
